import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CommonState from '@/services/locale-state'
import { computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageDropdown',
  props: {
  byTheme: {
    type: Boolean,
    default: false,
  },
  bgColor: {
    type: String,
    default: '',
  },
  textColor: {
    type: String,
    default: '',
  },
},
  setup(__props) {

_useCssVars(_ctx => ({
  "571c6917": (backgroundColor.value),
  "25872c25": (color.value)
}))

const { locale } = useI18n()
const language = ref(CommonState.getLocale() || locale)

const onChangeLocale = (lang: string) => {
  if (lang) {
    CommonState.setLocale(lang)
    locale.value = lang
  }
}

const langOption = ref([
  { label: 'TH', icon: 'th', value: 'th' },
  { label: 'EN', icon: 'uk', value: 'en' },
  { label: 'VN', icon: 'vn', value: 'vn' },
])

const props = __props

const backgroundColor = computed(() => props.bgColor)
const color = computed(() => props.textColor)
onMounted(() => {
  if (language.value) {
    onChangeLocale(language.value)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_SelectOption = _resolveComponent("SelectOption")!

  return (_openBlock(), _createBlock(_component_SelectOption, {
    modelValue: _unref(locale),
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => (_isRef(locale) ? (locale).value = $event : null)),
      onChangeLocale
    ],
    "from-lang": true,
    "by-theme": __props.byTheme,
    options: langOption.value,
    class: _normalizeClass(["m-0 z-99", backgroundColor.value && color.value && 'custom-bg-text-color'])
  }, null, 8, ["modelValue", "by-theme", "options", "class"]))
}
}

})